import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import InventoryIcon from '@mui/icons-material/Inventory';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import menuItemList from '../../../global/menuItemList';
import { useTranslation } from 'react-i18next';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import DiscountIcon from '@mui/icons-material/Discount';
import { hasPermissions } from '../../../auth/hasPermissions';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const Controls = ({
  cols,
  onNewPosition,
  onSelectProduct,
  onSelectService,
  onNewGroup,
  onNewDiscount,
  onNewHOAI,
  onNewTimeBilling,
  hideServices,
  hideProducts,
  hideNewPosition,
  hideSum,
  hideDiscount,
  hideGroups,
  hideHOAI = true,
  hideTimeBilling = true,
}) => {
  const { t } = useTranslation();
  return (
    <tr>
      <td colSpan={cols.length}>
        <Box
          className="w-full flex flex-row justify-center items-center h-0 mt-4"
          sx={{
            marginBottom: hideSum ? '15px' : '0px',
          }}
        >
          {!hideNewPosition && (
            <Tooltip title={t('Add Custom Position')} arrow>
              <IconButton onClick={onNewPosition}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          )}
          {!hideGroups && (
            <Tooltip title={t('Add Group')} arrow>
              <IconButton onClick={onNewGroup}>
                <GroupWorkIcon />
              </IconButton>
            </Tooltip>
          )}

          {hasPermissions('product', 'read') && !hideProducts && (
            <Tooltip title={t('Add Product Position')} arrow>
              <IconButton onClick={onSelectProduct}>
                <InventoryIcon />
              </IconButton>
            </Tooltip>
          )}

          {hasPermissions('service', 'read') && !hideServices && (
            <Tooltip title={t('Add Service Position')} arrow>
              <IconButton onClick={onSelectService}>
                <SupervisedUserCircleIcon />
              </IconButton>
            </Tooltip>
          )}
          {!hideDiscount && (
            <Tooltip title={t('Add Discount')} arrow>
              <IconButton onClick={onNewDiscount}>
                <DiscountIcon />
              </IconButton>
            </Tooltip>
          )}
          {!hideHOAI && (
            <Tooltip title={t('Add HOAI')} arrow>
              <IconButton
                onClick={onNewHOAI}
                sx={{
                  maxWidth: '37px',
                  maxHeight: '37px',
                  minWidth: '37px',
                  minHeight: '37px',
                }}
              >
                <Box className="aspect-square flex justify-center items-center">
                  <Typography fontSize={10} fontWeight={800}>
                    HOAI
                  </Typography>
                </Box>
              </IconButton>
            </Tooltip>
          )}
          {!hideTimeBilling && (
            <Tooltip title={t('Time Billing')}>
              <IconButton onClick={onNewTimeBilling}>
                <AccessTimeIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </td>
    </tr>
  );
};

export default Controls;
